import { useEffect, useRef } from "react";
import type { Dispatch, SetStateAction } from "react";
import type { ApprovalsFiltersResponse } from "../../../../../types/types.Workflow";
import {
  EMPTY_APPROVALS_LIST_FILTERS,
  isOnlySeededApproverFilter,
  isUserInApproverFilters,
} from "../ApprovalsList/approvalsList.types";
import type { ApprovalsListFiltersState } from "../ApprovalsList/approvalsList.types";

export function useSeedDefaultApproverFilter({
  user,
  apiFilters,
  setFilters,
}: {
  user: { id?: string } | null;
  apiFilters: ApprovalsFiltersResponse | undefined;
  setFilters: Dispatch<SetStateAction<ApprovalsListFiltersState>>;
}) {
  const confirmedForUserId = useRef<string | null>(null);

  useEffect(() => {
    if (!user?.id || !apiFilters) {
      return;
    }
    const userId = String(user.id);
    if (confirmedForUserId.current === userId) {
      return;
    }
    confirmedForUserId.current = userId;
    if (isUserInApproverFilters(userId, apiFilters)) {
      return;
    }
    setFilters((current) =>
      isOnlySeededApproverFilter(current, userId)
        ? EMPTY_APPROVALS_LIST_FILTERS
        : current
    );
  }, [apiFilters, setFilters, user]);
}
